export default "__VITE_ASSET__yUsq1nYI__"